// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1uxph","title":"InfoRow_title__2TLT1"};